// extracted by mini-css-extract-plugin
module.exports = {"page":"a10a3f92e9--page--OYngf"};